import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const SharedPage = loadAsyncComponent(
  () => import(/* webpackChunkName: "SharedPage" */ './Container'),
  'page'
);
